module.exports = __webpack_public_path__ + "static/media/logo.d478dc13.png";